// extracted by mini-css-extract-plugin
export default {"distribute_to_group":"Group_distribute_to_group__Qdmmu"};